module.exports = __webpack_public_path__ + "img/select-arrow-grey.289560f5.svg";